import queryString from 'query-string';

import { getRoutes, RouteName } from '../routes';

import { RouteParamsType, RouteType } from './types';

const findPathByRouteName = (
  name: string,
  routes: RouteType[],
): string | undefined =>
  routes
    .map((subroute) => {
      if (subroute.name === name) {
        return subroute.path;
      }

      if (subroute.routes) {
        return findPathByRouteName(name, subroute.routes);
      }

      return null;
    })
    .filter((subroute) => subroute && subroute.length > 0)
    .shift();

const replaceParams = (path: string, params: RouteParamsType): string => {
  return Object.keys(params).reduce((accumulator, currentValue) => {
    return accumulator.replace(`:${currentValue}`, params[currentValue]);
  }, path);
};

const routeTo = (
  name: RouteName,
  params?: RouteParamsType = {},
  query?: Record<string, unknown>,
): string => {
  const path = findPathByRouteName(name, getRoutes());
  if (!path) {
    return '/';
  }

  const route = replaceParams(path, params);

  if (query) {
    return `${route}?${queryString.stringify(query)}`;
  }

  return route;
};

export default routeTo;
